export default __webpack_public_path__ + "static/media/icon-dropoff-done.db29d76a.svg";